import { Link } from 'react-router-dom';
import { Button } from '@/components/ui';

function NotFound() {
  return (
    <div className="min-h-screen flex items-center justify-center bg-dark-base">
      <div className="text-center">
        <h1 className="text-6xl font-bold text-text-primary font-heading">404</h1>
        <p className="mt-4 text-xl text-text-secondary">Page not found</p>
        <p className="mt-2 text-text-muted">
          The page you're looking for doesn't exist.
        </p>
        <div className="mt-8">
          <Link to="/">
            <Button>Go to Dashboard</Button>
          </Link>
        </div>
      </div>
    </div>
  );
}

export default NotFound;
